import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { CTAButton } from '../ui/CTAButton';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-navy px-4 py-16 md:py-24" data-id="element-54" data-mp="1clpiikt3zysg">
      <div className="mx-auto max-w-6xl" data-id="element-55" data-mp="18kds4d2ev9j7">
        <SectionHeader tone="dark" kicker="Your 5 exclusive professional bonuses" title="Five Additional Resources to Complement Your Blueprint" intro={['Your purchase also includes five specialized educational resources designed to complement the main collection.', 'Each bonus focuses on a specific area of hair restoration education and documentation.']} data-id="element-56" data-mp="18lfevesshkgr" />

        <div className="mt-12 space-y-16 md:space-y-24" data-id="element-57" data-mp="kujg1xpx1p00">
          {bonuses.map((bonus, i) => <article key={bonus.number} className="grid items-center gap-6 lg:grid-cols-2 lg:gap-12" data-id="element-58" data-mp="fudwz5xppatj" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-59" data-mp="1et58qtslq16f">
                <img src={bonus.image} alt={`Bonus #${bonus.number}: ${bonus.title}`} className="w-full" loading="lazy" data-id="element-60" data-mp="1jshsh5o6es4s" />
              </div>

              <div data-id="element-61" data-mp="1ar0f3v25l4js">
                <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 font-display text-sm font-black uppercase text-ink" data-id="element-62" data-mp="1aqi946povbyo">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="10tm1023pcrun" />
                  Bonus #{bonus.number}
                </span>
                <h3 className="mt-4 text-balance font-display text-[28px] font-black leading-tight text-white md:text-4xl" data-id="element-64" data-mp="n3iinm7y1iah">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-lg font-bold text-cyan" data-id="element-65" data-mp="d3rpbnv4d9bz">{bonus.tagline}</p>
                <div className="mt-4 space-y-3 text-[16px] leading-relaxed text-white/75" data-id="element-66" data-mp="i3e9kh9d7pua">
                  {bonus.description.map(p => <p key={p} data-id="element-67" data-mp="2jtd59r05ql48">{p}</p>)}
                </div>

                <div className="mt-6 rounded-2xl bg-navy-2 p-5" data-id="element-68" data-mp="2f1lbz8pma1ae">
                  <p className="font-display text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-69" data-mp="2b09ll0yx5c15">Inside this resource</p>
                  <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-70" data-mp="261ybqq8mj1ix">
                    {bonus.inside.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-71" data-mp="32q4mzw01ws66">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-72" data-mp="2ypavksnegv8j" />
                        <span className="text-[15px] leading-snug text-white/90" data-id="element-73" data-mp="2tpohyi3ntcz7">{item}</span>
                      </li>)}
                  </ul>
                </div>

                {bonus.note && <p className="mt-4 text-sm italic text-white/55" data-id="element-74" data-mp="1icdqu1swtu70">{bonus.note}</p>}

                <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-75" data-mp="1dc85f3d8h3xd">
                  <p className="text-[16px] text-white/70" data-id="element-76" data-mp="138knqmknd403">
                    Suggested comparison value: <span className="font-bold text-dangerSoft line-through" data-id="element-77" data-mp="136q6pjchxw1a">${bonus.value}</span>
                  </p>
                  <span className="rounded-lg bg-success px-3 py-1.5 text-sm font-extrabold uppercase text-white" data-id="element-78" data-mp="1d70f8qnl6fa4">
                    Included with your purchase
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-79" data-mp="1m1etqr0alls6">
          <p className="text-[17px] text-white/75" data-id="element-80" data-mp="1qwuaprtljxst">
            Receive all five complementary educational resources as part of your complete collection.
          </p>
          <div className="mt-6" data-id="element-81" data-mp="20wurb602zztb">
            <CTAButton label="Yes, I want all 5 bonuses" sub="Just $27 USD · One-time payment" data-id="element-82" data-mp="20vt6i9t9jyye" />
          </div>
        </div>
      </div>
    </section>;
}